export const setTitle = (title: string, concatAppName = true) => {
  const appName = " | eGAM 🤝 Você";
  document.title = title + (concatAppName ? appName : "");
};
